import React from 'react';

export default function HasilInterview() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Hasil Interview</h1>
      <p className="text-gray-500">Halaman Hasil Interview</p>
    </div>
  );
}
